import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ReOrderCopiedCitationCommand from './reordercopiedcitationcommand';

export default class ReOrderCopiedCitationEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add('reordercopiedcitation', new ReOrderCopiedCitationCommand(editor, 'reordercopiedcitation'));
  }
}